module.exports = __webpack_public_path__ + "static/media/S4_04.b5caa1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE4strobe/S4_04.png
// module id = 202
// module chunks = 0